function PlanFF({ ...props }) {
	return (
		<g {...props} id="unit-f">
			<g id="furniture">
				<polyline
					points="636.51 647.39 419.22 647.39 419.22 592.88 636.51 592.88 636.51 647.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="414.21 584.92 414.21 579.96 416.72 579.96 416.72 584.92 414.21 584.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="290.31"
					y1="407.47"
					x2="157.02"
					y2="407.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="441.54"
					x2="290.31"
					y2="407.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.13"
					y1="441.54"
					x2="204.58"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.85"
					y1="441.54"
					x2="213.3"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.57"
					y1="441.54"
					x2="222.03"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.3"
					y1="441.54"
					x2="230.75"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.02"
					y1="441.54"
					x2="239.47"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.74"
					y1="441.54"
					x2="248.19"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.46"
					y1="441.54"
					x2="256.91"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.18"
					y1="441.54"
					x2="265.63"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.9"
					y1="441.54"
					x2="274.36"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.63"
					y1="441.54"
					x2="283.08"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.35"
					y1="441.54"
					x2="290.31"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="441.54"
					x2="290.31"
					y2="436"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="432.73"
					x2="290.31"
					y2="427.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="424.01"
					x2="290.31"
					y2="418.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="415.28"
					x2="290.31"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.31"
					y1="409.74"
					x2="286.35"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.08"
					y1="409.74"
					x2="277.63"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.36"
					y1="409.74"
					x2="268.9"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.63"
					y1="409.74"
					x2="260.18"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.91"
					y1="409.74"
					x2="251.46"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.19"
					y1="409.74"
					x2="242.74"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.47"
					y1="409.74"
					x2="234.02"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.75"
					y1="409.74"
					x2="225.3"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.03"
					y1="409.74"
					x2="216.57"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.3"
					y1="409.74"
					x2="207.85"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.58"
					y1="409.74"
					x2="199.13"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.86"
					y1="409.74"
					x2="190.41"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.14"
					y1="409.74"
					x2="181.69"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="178.42"
					y1="409.74"
					x2="172.97"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.7"
					y1="409.74"
					x2="164.25"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.98"
					y1="409.74"
					x2="157.02"
					y2="409.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.02"
					y1="409.74"
					x2="157.02"
					y2="415.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.02"
					y1="418.56"
					x2="157.02"
					y2="424.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.91"
					y1="614.52"
					x2="808.91"
					y2="695.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.45"
					y1="614.52"
					x2="820"
					y2="614.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.73"
					y1="614.52"
					x2="811.18"
					y2="614.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="614.52"
					x2="811.18"
					y2="618.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="621.82"
					x2="811.18"
					y2="627.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="630.54"
					x2="811.18"
					y2="635.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="639.26"
					x2="811.18"
					y2="644.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="647.98"
					x2="811.18"
					y2="653.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="656.71"
					x2="811.18"
					y2="662.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="665.43"
					x2="811.18"
					y2="670.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="674.15"
					x2="811.18"
					y2="679.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="682.87"
					x2="811.18"
					y2="688.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="691.59"
					x2="811.18"
					y2="695.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.18"
					y1="695.62"
					x2="816.73"
					y2="695.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820"
					y1="695.62"
					x2="825.45"
					y2="695.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.95 387.97 829.06 387.97 829.06 444.09 772.95 444.09 772.95 387.97"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="216.46 53.65 216.46 58.57 254.57 58.57 254.57 53.65 216.46 53.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="256.36 53.2 214.67 53.2 214.67 53.65 256.36 53.65 256.36 53.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="256.36"
					y1="53.65"
					x2="256.36"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.67"
					y1="53.65"
					x2="256.36"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.67"
					y1="53.2"
					x2="214.67"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.36"
					y1="53.2"
					x2="214.67"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="58.57"
					x2="254.57"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.57"
					y1="53.65"
					x2="216.46"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="212.44 58.57 216.46 58.57 216.46 53.65 212.44 53.65 212.44 58.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="212.44"
					y1="53.65"
					x2="212.44"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="53.65"
					x2="212.44"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="58.57"
					x2="216.46"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.44"
					y1="58.57"
					x2="216.46"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="258.6 53.65 254.57 53.65 254.57 58.57 258.6 58.57 258.6 53.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="258.6"
					y1="58.57"
					x2="258.6"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.57"
					y1="58.57"
					x2="258.6"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.57"
					y1="53.65"
					x2="254.57"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.6"
					y1="53.65"
					x2="254.57"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="54.54"
					x2="254.57"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="210.65 58.12 212.44 58.12 212.44 53.65 214.67 53.65 214.67 53.2 210.65 53.2 210.65 58.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="210.65"
					y1="53.2"
					x2="210.65"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.67"
					y1="53.2"
					x2="210.65"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.67"
					y1="53.65"
					x2="214.67"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.44"
					y1="53.65"
					x2="214.67"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.44"
					y1="58.12"
					x2="212.44"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.65"
					y1="58.12"
					x2="212.44"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="260.39 53.2 256.36 53.2 256.36 53.65 258.6 53.65 258.6 58.12 260.39 58.12 260.39 53.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="260.39"
					y1="58.12"
					x2="260.39"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.6"
					y1="58.12"
					x2="260.39"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.6"
					y1="53.65"
					x2="258.6"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.36"
					y1="53.65"
					x2="258.6"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.36"
					y1="53.2"
					x2="256.36"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.39"
					y1="53.2"
					x2="256.36"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="262.66 54.54 262.66 56.81 354.73 56.81 354.73 54.54 262.66 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.73"
					y1="54.54"
					x2="262.66"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.73"
					y1="56.81"
					x2="354.73"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.66"
					y1="56.81"
					x2="354.73"
					y2="56.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.66"
					y1="54.54"
					x2="262.66"
					y2="56.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="210.65 54.54 210.65 68.17 206.1 68.17 206.1 54.54 210.65 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="210.65"
					y1="68.17"
					x2="210.65"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.1"
					y1="68.17"
					x2="210.65"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.1"
					y1="54.54"
					x2="206.1"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.65"
					y1="54.54"
					x2="206.1"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="264.93 54.54 264.93 68.17 260.39 68.17 260.39 54.54 264.93 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="264.93"
					y1="68.17"
					x2="264.93"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.39"
					y1="68.17"
					x2="264.93"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.39"
					y1="54.54"
					x2="260.39"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.93"
					y1="54.54"
					x2="260.39"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="357 54.54 357 68.17 352.46 68.17 352.46 54.54 357 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="357"
					y1="68.17"
					x2="357"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.46"
					y1="68.17"
					x2="357"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.46"
					y1="54.54"
					x2="352.46"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357"
					y1="54.54"
					x2="352.46"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="489.72 53.65 489.72 58.57 527.25 58.57 527.25 53.65 489.72 53.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="529.04 53.2 487.93 53.2 487.93 53.65 529.04 53.65 529.04 53.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.04"
					y1="53.65"
					x2="529.04"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.93"
					y1="53.65"
					x2="529.04"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.93"
					y1="53.2"
					x2="487.93"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.04"
					y1="53.2"
					x2="487.93"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.72"
					y1="58.57"
					x2="527.25"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.25"
					y1="53.65"
					x2="489.72"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="485.7 58.57 489.72 58.57 489.72 53.65 485.7 53.65 485.7 58.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="485.7"
					y1="53.65"
					x2="485.7"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.72"
					y1="53.65"
					x2="485.7"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.72"
					y1="58.57"
					x2="489.72"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.7"
					y1="58.57"
					x2="489.72"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="531.27 53.65 527.25 53.65 527.25 58.57 531.27 58.57 531.27 53.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="531.27"
					y1="58.57"
					x2="531.27"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.25"
					y1="58.57"
					x2="531.27"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.25"
					y1="53.65"
					x2="527.25"
					y2="58.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.27"
					y1="53.65"
					x2="527.25"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.72"
					y1="54.54"
					x2="527.25"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.91 58.12 485.7 58.12 485.7 53.65 487.93 53.65 487.93 53.2 483.91 53.2 483.91 58.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="483.91"
					y1="53.2"
					x2="483.91"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.93"
					y1="53.2"
					x2="483.91"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="487.93"
					y1="53.65"
					x2="487.93"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.7"
					y1="53.65"
					x2="487.93"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.7"
					y1="58.12"
					x2="485.7"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.91"
					y1="58.12"
					x2="485.7"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="533.06 53.2 529.04 53.2 529.04 53.65 531.27 53.65 531.27 58.12 533.06 58.12 533.06 53.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="533.06"
					y1="58.12"
					x2="533.06"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.27"
					y1="58.12"
					x2="533.06"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.27"
					y1="53.65"
					x2="531.27"
					y2="58.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.04"
					y1="53.65"
					x2="531.27"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.04"
					y1="53.2"
					x2="529.04"
					y2="53.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.06"
					y1="53.2"
					x2="529.04"
					y2="53.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="535.33 54.54 535.33 56.81 655.05 56.81 655.05 54.54 535.33 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="655.05"
					y1="54.54"
					x2="535.33"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.05"
					y1="56.81"
					x2="655.05"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.33"
					y1="56.81"
					x2="655.05"
					y2="56.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.33"
					y1="54.54"
					x2="535.33"
					y2="56.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="483.91 54.54 483.91 68.17 479.37 68.17 479.37 54.54 483.91 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="483.91"
					y1="68.17"
					x2="483.91"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.37"
					y1="68.17"
					x2="483.91"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.37"
					y1="54.54"
					x2="479.37"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.91"
					y1="54.54"
					x2="479.37"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="537.6 54.54 537.6 68.17 533.06 68.17 533.06 54.54 537.6 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.6"
					y1="68.17"
					x2="537.6"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.06"
					y1="68.17"
					x2="537.6"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.06"
					y1="54.54"
					x2="533.06"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.6"
					y1="54.54"
					x2="533.06"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="657.33 54.54 657.33 68.17 652.78 68.17 652.78 54.54 657.33 54.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="657.33"
					y1="68.17"
					x2="657.33"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.78"
					y1="68.17"
					x2="657.33"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.78"
					y1="54.54"
					x2="652.78"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.33"
					y1="54.54"
					x2="652.78"
					y2="54.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="794.01"
					x2="779.49"
					y2="775.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="657.33"
					y1="50"
					x2="657.33"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="419.22"
					y1="665.65"
					x2="343.96"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="665.65"
					x2="197.94"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="419.22"
					y1="647.39"
					x2="419.22"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="636.51"
					y1="647.39"
					x2="618.34"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="419.22"
					y1="647.39"
					x2="437.39"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="618.34"
					y1="647.39"
					x2="437.39"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="636.51"
					y1="665.65"
					x2="636.51"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="948.86"
					x2="784.1"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="784.1"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="780.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="948.86"
					x2="690.98"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="690.98"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="694.38"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="695.52 950 695.52 948.86 690.98 948.86 690.98 950 695.52 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="779.55 948.86 779.55 950 784.1 950 784.1 948.86 779.55 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="695.52 930.69 695.52 929.56 690.98 929.56 690.98 930.69 695.52 930.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="779.55 929.56 779.55 930.69 784.1 930.69 784.1 929.56 779.55 929.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="695.52"
					y1="950"
					x2="690.98"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.98"
					y1="950"
					x2="690.98"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.98"
					y1="948.86"
					x2="695.52"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.52"
					y1="948.86"
					x2="695.52"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.55"
					y1="948.86"
					x2="784.1"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.1"
					y1="948.86"
					x2="784.1"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.1"
					y1="950"
					x2="779.55"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.55"
					y1="950"
					x2="779.55"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.52"
					y1="930.69"
					x2="690.98"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.98"
					y1="930.69"
					x2="690.98"
					y2="929.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.98"
					y1="929.56"
					x2="695.52"
					y2="929.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.52"
					y1="929.56"
					x2="695.52"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.55"
					y1="929.56"
					x2="784.1"
					y2="929.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.1"
					y1="929.56"
					x2="784.1"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.1"
					y1="930.69"
					x2="779.55"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.55"
					y1="930.69"
					x2="779.55"
					y2="929.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="696.65 948.86 696.65 930.69 694.95 930.69 694.95 948.86 696.65 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="780.12 948.86 780.12 930.69 778.42 930.69 778.42 948.86 780.12 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="720.6 872.88 717.79 875.69 775.61 933.5 778.42 930.69 720.6 872.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.95"
					y1="930.69"
					x2="694.38"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.95"
					y1="948.86"
					x2="694.38"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="694.38"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.12"
					y1="930.69"
					x2="780.69"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.12"
					y1="948.86"
					x2="780.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="780.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.65"
					y1="948.86"
					x2="696.65"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.65"
					y1="930.69"
					x2="694.95"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.95"
					y1="930.69"
					x2="694.95"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.95"
					y1="948.86"
					x2="696.65"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.12"
					y1="948.86"
					x2="780.12"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.12"
					y1="930.69"
					x2="778.42"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.42"
					y1="930.69"
					x2="778.42"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.42"
					y1="948.86"
					x2="780.12"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.6"
					y1="872.88"
					x2="717.79"
					y2="875.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.79"
					y1="875.69"
					x2="775.61"
					y2="933.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.61"
					y1="933.5"
					x2="778.42"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.42"
					y1="930.69"
					x2="720.6"
					y2="872.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="694.38"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="694.38"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="690.98"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="930.69"
					x2="690.98"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="948.86"
					x2="690.98"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="694.38"
					y1="948.86"
					x2="690.98"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="780.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="780.69"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="784.1"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="930.69"
					x2="784.1"
					y2="930.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="948.86"
					x2="784.1"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="780.69"
					y1="948.86"
					x2="784.1"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="384.26"
					x2="767.06"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="755.71"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="767.06"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="447.86"
					x2="767.06"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="755.71"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="767.06"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="768.2 446.72 767.06 446.72 767.06 451.27 768.2 451.27 768.2 446.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="767.06 385.4 768.2 385.4 768.2 380.86 767.06 380.86 767.06 385.4"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="755.71 446.72 754.57 446.72 754.57 451.27 755.71 451.27 755.71 446.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="754.57 385.4 755.71 385.4 755.71 380.86 754.57 380.86 754.57 385.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="768.2"
					y1="446.72"
					x2="768.2"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.2"
					y1="451.27"
					x2="767.06"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="451.27"
					x2="767.06"
					y2="446.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="446.72"
					x2="768.2"
					y2="446.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="385.4"
					x2="767.06"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="380.86"
					x2="768.2"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.2"
					y1="380.86"
					x2="768.2"
					y2="385.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.2"
					y1="385.4"
					x2="767.06"
					y2="385.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="446.72"
					x2="755.71"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="451.27"
					x2="754.57"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.57"
					y1="451.27"
					x2="754.57"
					y2="446.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.57"
					y1="446.72"
					x2="755.71"
					y2="446.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.57"
					y1="385.4"
					x2="754.57"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.57"
					y1="380.86"
					x2="755.71"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="380.86"
					x2="755.71"
					y2="385.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="385.4"
					x2="754.57"
					y2="385.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="767.06 445.59 755.71 445.59 755.71 447.29 767.06 447.29 767.06 445.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="767.06 384.83 755.71 384.83 755.71 386.54 767.06 386.54 767.06 384.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="713.95 428.29 716.76 431.1 758.52 389.35 755.71 386.54 713.95 428.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.71"
					y1="447.29"
					x2="755.71"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="447.29"
					x2="767.06"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="767.06"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="384.83"
					x2="755.71"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="384.83"
					x2="767.06"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="767.06"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="445.59"
					x2="755.71"
					y2="445.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="445.59"
					x2="755.71"
					y2="447.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="447.29"
					x2="767.06"
					y2="447.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="447.29"
					x2="767.06"
					y2="445.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="384.83"
					x2="755.71"
					y2="384.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="384.83"
					x2="755.71"
					y2="386.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="386.54"
					x2="767.06"
					y2="386.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.06"
					y1="386.54"
					x2="767.06"
					y2="384.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.95"
					y1="428.29"
					x2="716.76"
					y2="431.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.76"
					y1="431.1"
					x2="758.52"
					y2="389.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.52"
					y1="389.35"
					x2="755.71"
					y2="386.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="386.54"
					x2="713.95"
					y2="428.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.71,445.59c-14.29,0-28.09-5.18-38.85-14.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="767.06"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="767.06"
					y2="447.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="755.71"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="447.86"
					x2="755.71"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="447.86"
					x2="767.06"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="447.86"
					x2="767.06"
					y2="451.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="767.06"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="767.06"
					y2="384.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="755.71"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="755.71"
					y1="384.26"
					x2="755.71"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="384.26"
					x2="767.06"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="767.06"
					y1="384.26"
					x2="767.06"
					y2="380.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="626.22"
					x2="790.84"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="779.49"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="790.84"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="685.27"
					x2="790.84"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="779.49"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="790.84"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="791.98 684.13 790.84 684.13 790.84 688.68 791.98 688.68 791.98 684.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="790.84 627.35 791.98 627.35 791.98 622.81 790.84 622.81 790.84 627.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="779.49 684.13 778.35 684.13 778.35 688.68 779.49 688.68 779.49 684.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="778.35 627.35 779.49 627.35 779.49 622.81 778.35 622.81 778.35 627.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="791.98"
					y1="684.13"
					x2="791.98"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.98"
					y1="688.68"
					x2="790.84"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="688.68"
					x2="790.84"
					y2="684.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="684.13"
					x2="791.98"
					y2="684.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="627.35"
					x2="790.84"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="622.81"
					x2="791.98"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.98"
					y1="622.81"
					x2="791.98"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.98"
					y1="627.35"
					x2="790.84"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="684.13"
					x2="779.49"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="688.68"
					x2="778.35"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.35"
					y1="688.68"
					x2="778.35"
					y2="684.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.35"
					y1="684.13"
					x2="779.49"
					y2="684.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.35"
					y1="627.35"
					x2="778.35"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.35"
					y1="622.81"
					x2="779.49"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="622.81"
					x2="779.49"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="627.35"
					x2="778.35"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="790.84 683 779.49 683 779.49 684.7 790.84 684.7 790.84 683"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="790.84 626.79 779.49 626.79 779.49 628.49 790.84 628.49 790.84 626.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="740.94 667.03 743.75 669.84 782.3 631.3 779.49 628.49 740.94 667.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="779.49"
					y1="684.7"
					x2="779.49"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="684.7"
					x2="790.84"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="790.84"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="626.79"
					x2="779.49"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="626.79"
					x2="790.84"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="790.84"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="683"
					x2="779.49"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="683"
					x2="779.49"
					y2="684.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="684.7"
					x2="790.84"
					y2="684.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="684.7"
					x2="790.84"
					y2="683"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="626.79"
					x2="779.49"
					y2="626.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="626.79"
					x2="779.49"
					y2="628.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="628.49"
					x2="790.84"
					y2="628.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.84"
					y1="628.49"
					x2="790.84"
					y2="626.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.94"
					y1="667.03"
					x2="743.75"
					y2="669.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.75"
					y1="669.84"
					x2="782.3"
					y2="631.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="782.3"
					y1="631.3"
					x2="779.49"
					y2="628.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="628.49"
					x2="740.94"
					y2="667.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="790.84"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="790.84"
					y2="685.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="779.49"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="685.27"
					x2="779.49"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="685.27"
					x2="790.84"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="685.27"
					x2="790.84"
					y2="688.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="790.84"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="790.84"
					y2="626.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="779.49"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="779.49"
					y1="626.22"
					x2="779.49"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="626.22"
					x2="790.84"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="790.84"
					y1="626.22"
					x2="790.84"
					y2="622.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="452.9"
					x2="345.79"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="345.79"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="349.2"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="350.34 454.03 350.34 452.9 345.79 452.9 345.79 454.03 350.34 454.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="350.34 441.54 350.34 440.4 345.79 440.4 345.79 441.54 350.34 441.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="350.34"
					y1="454.03"
					x2="345.79"
					y2="454.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.79"
					y1="454.03"
					x2="345.79"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.79"
					y1="452.9"
					x2="350.34"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.34"
					y1="452.9"
					x2="350.34"
					y2="454.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.29"
					y1="454.03"
					x2="425.29"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.34"
					y1="441.54"
					x2="345.79"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.79"
					y1="441.54"
					x2="345.79"
					y2="440.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.79"
					y1="440.4"
					x2="350.34"
					y2="440.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.34"
					y1="440.4"
					x2="350.34"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.29"
					y1="441.54"
					x2="425.29"
					y2="440.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="351.47 452.9 351.47 441.54 349.77 441.54 349.77 452.9 351.47 452.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="372.76 390.15 369.95 392.96 421.34 444.35 424.15 441.54 372.76 390.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.77"
					y1="441.54"
					x2="349.2"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.77"
					y1="452.9"
					x2="349.2"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="349.2"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.47"
					y1="452.9"
					x2="351.47"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.47"
					y1="441.54"
					x2="349.77"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.77"
					y1="441.54"
					x2="349.77"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.77"
					y1="452.9"
					x2="351.47"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.15"
					y1="441.54"
					x2="424.15"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.76"
					y1="390.15"
					x2="369.95"
					y2="392.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.95"
					y1="392.96"
					x2="421.34"
					y2="444.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.34"
					y1="444.35"
					x2="424.15"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.15"
					y1="441.54"
					x2="372.76"
					y2="390.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="349.2"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="349.2"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="345.79"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="441.54"
					x2="345.79"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="452.9"
					x2="345.79"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="349.2"
					y1="452.9"
					x2="345.79"
					y2="452.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="464.2"
					x2="343.96"
					y2="460.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="464.2"
					x2="343.96"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="541.43"
					x2="343.96"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="332.6"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="343.96"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="345.09 540.29 343.96 540.29 343.96 544.83 345.09 544.83 345.09 540.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="343.96 465.34 345.09 465.34 345.09 460.79 343.96 460.79 343.96 465.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="332.6 540.29 331.46 540.29 331.46 544.83 332.6 544.83 332.6 540.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="345.09"
					y1="540.29"
					x2="345.09"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.09"
					y1="544.83"
					x2="343.96"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="544.83"
					x2="343.96"
					y2="540.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="540.29"
					x2="345.09"
					y2="540.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="465.34"
					x2="343.96"
					y2="460.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="460.8"
					x2="345.09"
					y2="460.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.09"
					y1="460.8"
					x2="345.09"
					y2="465.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.09"
					y1="465.34"
					x2="343.96"
					y2="465.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="540.29"
					x2="332.6"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="544.83"
					x2="331.46"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.46"
					y1="544.83"
					x2="331.46"
					y2="540.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.46"
					y1="540.29"
					x2="332.6"
					y2="540.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="465.34"
					x2="331.46"
					y2="465.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.96 539.15 332.6 539.15 332.6 540.86 343.96 540.86 343.96 539.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="343.96 464.77 332.6 464.77 332.6 466.47 343.96 466.47 343.96 464.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="281.21 517.86 284.02 520.67 335.41 469.28 332.6 466.47 281.21 517.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.6"
					y1="540.86"
					x2="332.6"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="540.86"
					x2="343.96"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="343.96"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="464.77"
					x2="332.6"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="464.77"
					x2="343.96"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="464.2"
					x2="343.96"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="539.15"
					x2="332.6"
					y2="539.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="539.15"
					x2="332.6"
					y2="540.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="540.86"
					x2="343.96"
					y2="540.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="540.86"
					x2="343.96"
					y2="539.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="464.77"
					x2="332.6"
					y2="464.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="464.77"
					x2="332.6"
					y2="466.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="466.47"
					x2="343.96"
					y2="466.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="466.47"
					x2="343.96"
					y2="464.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.21"
					y1="517.86"
					x2="284.02"
					y2="520.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.02"
					y1="520.67"
					x2="335.41"
					y2="469.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.41"
					y1="469.28"
					x2="332.6"
					y2="466.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="466.47"
					x2="281.21"
					y2="517.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="343.96"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="343.96"
					y2="541.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="332.6"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="541.43"
					x2="332.6"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="541.43"
					x2="343.96"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="541.43"
					x2="343.96"
					y2="544.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="464.2"
					x2="343.96"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="332.6"
					y1="464.2"
					x2="343.96"
					y2="464.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="464.2"
					x2="343.96"
					y2="460.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="343.96"
					y1="464.2"
					x2="343.96"
					y2="460.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="197.94"
					y1="665.65"
					x2="197.94"
					y2="595.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="197.94"
					y1="595.52"
					x2="186.58"
					y2="595.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="186.58"
					y1="595.52"
					x2="180.33"
					y2="595.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.31"
					y1="390.77"
					x2="290.31"
					y2="441.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="390.77"
					x2="166.59"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="388.49"
					x2="169.43"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="166.59"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="169.43"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="390.77"
					x2="282.42"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="388.49"
					x2="279.58"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="282.42"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="279.58"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="290.31"
					y1="379.41"
					x2="279.58"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="390.77"
					x2="290.31"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="277.88 388.49 277.88 390.77 279.01 390.77 279.01 388.49 277.88 388.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="277.88 391.9 282.42 391.9 282.42 390.77 277.88 390.77 277.88 391.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="169.99 388.49 169.99 390.77 171.13 390.77 171.13 388.49 169.99 388.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="171.13 390.77 166.59 390.77 166.59 391.9 171.13 391.9 171.13 390.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="277.88 379.41 282.42 379.41 282.42 376.57 277.88 376.57 277.88 379.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="171.13 376.57 166.59 376.57 166.59 379.41 171.13 379.41 171.13 376.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="277.88"
					y1="388.49"
					x2="277.88"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.88"
					y1="390.77"
					x2="279.01"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.01"
					y1="390.77"
					x2="279.01"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.01"
					y1="388.49"
					x2="277.88"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.88"
					y1="391.9"
					x2="282.42"
					y2="391.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.42"
					y1="391.9"
					x2="282.42"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.42"
					y1="390.77"
					x2="277.88"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.88"
					y1="390.77"
					x2="277.88"
					y2="391.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="388.49"
					x2="169.99"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="390.77"
					x2="171.13"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="390.77"
					x2="171.13"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="388.49"
					x2="169.99"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="390.77"
					x2="166.59"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.59"
					y1="390.77"
					x2="166.59"
					y2="391.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.59"
					y1="391.9"
					x2="171.13"
					y2="391.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="391.9"
					x2="171.13"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.88"
					y1="379.41"
					x2="282.42"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.42"
					y1="379.41"
					x2="282.42"
					y2="376.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.42"
					y1="376.57"
					x2="277.88"
					y2="376.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.88"
					y1="376.57"
					x2="277.88"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="376.57"
					x2="166.59"
					y2="376.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.59"
					y1="376.57"
					x2="166.59"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.59"
					y1="379.41"
					x2="171.13"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.13"
					y1="379.41"
					x2="171.13"
					y2="376.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="274.47 388.49 279.01 388.49 279.01 379.41 274.47 379.41 274.47 388.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="169.99 388.49 174.54 388.49 174.54 379.41 169.99 379.41 169.99 388.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="226.77 379.41 174.54 379.41 174.54 383.38 226.77 383.38 226.77 379.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="247.21 383.38 194.98 383.38 194.98 387.36 247.21 387.36 247.21 383.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="279.01"
					y1="379.41"
					x2="279.58"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.01"
					y1="388.49"
					x2="279.58"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="279.58"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="379.41"
					x2="169.43"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="388.49"
					x2="169.43"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="169.43"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="388.49"
					x2="274.47"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.47"
					y1="379.41"
					x2="279.01"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.01"
					y1="379.41"
					x2="279.01"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.01"
					y1="388.49"
					x2="274.47"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="388.49"
					x2="169.99"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="169.99"
					y1="379.41"
					x2="174.54"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.54"
					y1="379.41"
					x2="174.54"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.54"
					y1="388.49"
					x2="169.99"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.77"
					y1="379.41"
					x2="226.77"
					y2="383.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.77"
					y1="383.38"
					x2="174.54"
					y2="383.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.54"
					y1="383.38"
					x2="174.54"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="174.54"
					y1="379.41"
					x2="226.77"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.21"
					y1="383.38"
					x2="247.21"
					y2="387.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.21"
					y1="387.36"
					x2="194.98"
					y2="387.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.98"
					y1="387.36"
					x2="194.98"
					y2="383.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.98"
					y1="383.38"
					x2="247.21"
					y2="383.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="279.58"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="279.58"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="388.49"
					x2="279.58"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="379.41"
					x2="282.42"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="388.49"
					x2="279.58"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="390.77"
					x2="282.42"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="279.58"
					y1="390.77"
					x2="282.42"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="169.43"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="169.43"
					y2="388.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="388.49"
					x2="169.43"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="379.41"
					x2="166.59"
					y2="379.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="388.49"
					x2="169.43"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="390.77"
					x2="166.59"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="169.43"
					y1="390.77"
					x2="166.59"
					y2="390.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="206.1"
					y1="50"
					x2="206.1"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="357"
					y1="50"
					x2="357"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="479.37"
					y1="68.17"
					x2="479.37"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="239.97 502.11 241.78 498.05 242.41 493.66 241.78 489.27 239.97 485.21 237.68 482.54 234.8 480.52 228.04 477.94 219.58 477.05 211.28 478.95 203.83 478.32 197.03 475.22 195.11 474 191.16 472.56 186.97 472.77 185.31 473.42 180.9 473.42 180.9 475.26 182.91 475.26 181.05 478.34 180.33 481.86 180.33 505.46 181.56 510.02 184.8 513.44 189.29 514.91 189.83 514.91 192.67 514.44 197.14 512.05 203.86 508.96 211.23 508.35 219.55 510.27 228.04 509.37 234.8 506.8 237.68 504.78 239.97 502.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="201.3"
					y1="485.25"
					x2="201.3"
					y2="502.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="505.46"
					x2="180.33"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.18"
					y1="505.46"
					x2="181.18"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="481.86"
					x2="180.33"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.18"
					y1="481.86"
					x2="181.18"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.3"
					y1="501.63"
					x2="198.16"
					y2="501.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.16"
					y1="501.63"
					x2="198.16"
					y2="499.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.16"
					y1="499.03"
					x2="201.3"
					y2="499.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.3"
					y1="485.69"
					x2="198.16"
					y2="485.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.16"
					y1="485.69"
					x2="198.16"
					y2="488.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.16"
					y1="488.29"
					x2="201.3"
					y2="488.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.71"
					y1="475.26"
					x2="180.9"
					y2="475.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.71"
					y1="473.42"
					x2="180.9"
					y2="473.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.9"
					y1="473.42"
					x2="180.9"
					y2="475.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.71"
					y1="473.42"
					x2="188.71"
					y2="475.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.41"
					y1="493.66"
					x2="242.09"
					y2="496.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.09"
					y1="496.48"
					x2="241.36"
					y2="499.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.36"
					y1="499.21"
					x2="239.97"
					y2="502.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.97"
					y1="502.11"
					x2="237.68"
					y2="504.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.68"
					y1="504.78"
					x2="234.8"
					y2="506.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.8"
					y1="506.8"
					x2="231.52"
					y2="508.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.52"
					y1="508.29"
					x2="228.04"
					y2="509.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.04"
					y1="509.37"
					x2="222.41"
					y2="510.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.41"
					y1="510.36"
					x2="219.58"
					y2="510.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.58"
					y1="510.41"
					x2="216.75"
					y2="510.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.75"
					y1="510.09"
					x2="212.37"
					y2="508.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="508.81"
					x2="208.12"
					y2="506.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.12"
					y1="506.82"
					x2="204.33"
					y2="504.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.33"
					y1="504.46"
					x2="201.3"
					y2="502.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.23"
					y1="508.35"
					x2="207.29"
					y2="508.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.29"
					y1="508.37"
					x2="203.46"
					y2="509.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.46"
					y1="509.02"
					x2="201.4"
					y2="509.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.4"
					y1="509.69"
					x2="199.35"
					y2="510.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="510.65"
					x2="196.38"
					y2="512.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.38"
					y1="512.55"
					x2="193.3"
					y2="514.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.3"
					y1="514.22"
					x2="190.29"
					y2="514.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.29"
					y1="514.89"
					x2="187.3"
					y2="514.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.3"
					y1="514.64"
					x2="184.57"
					y2="513.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.57"
					y1="513.47"
					x2="182.38"
					y2="511.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.38"
					y1="511.41"
					x2="181.27"
					y2="509.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.27"
					y1="509.39"
					x2="180.65"
					y2="507.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.65"
					y1="507.47"
					x2="180.33"
					y2="505.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.18"
					y1="505.46"
					x2="181.26"
					y2="506.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.26"
					y1="506.36"
					x2="181.84"
					y2="508.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.84"
					y1="508.21"
					x2="183.22"
					y2="509.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.22"
					y1="509.85"
					x2="185.14"
					y2="510.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.14"
					y1="510.88"
					x2="187.68"
					y2="511.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.68"
					y1="511.37"
					x2="190.29"
					y2="511.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.29"
					y1="511.48"
					x2="191.58"
					y2="511.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.58"
					y1="511.46"
					x2="192.61"
					y2="510.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.61"
					y1="510.91"
					x2="192.91"
					y2="510.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.91"
					y1="510.28"
					x2="194.94"
					y2="503.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.94"
					y1="503.14"
					x2="195.54"
					y2="499.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.54"
					y1="499.59"
					x2="195.8"
					y2="496"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.8"
					y1="496"
					x2="195.8"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.28"
					y1="478.95"
					x2="207.34"
					y2="478.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.34"
					y1="478.92"
					x2="203.49"
					y2="478.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.49"
					y1="478.27"
					x2="199.35"
					y2="476.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.35"
					y1="476.67"
					x2="196.37"
					y2="474.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.37"
					y1="474.78"
					x2="193.3"
					y2="473.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.3"
					y1="473.1"
					x2="191.29"
					y2="472.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.29"
					y1="472.55"
					x2="189.23"
					y2="472.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.23"
					y1="472.42"
					x2="187.2"
					y2="472.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.2"
					y1="472.71"
					x2="185.31"
					y2="473.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.18"
					y1="481.86"
					x2="181.26"
					y2="480.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.26"
					y1="480.96"
					x2="181.84"
					y2="479.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.84"
					y1="479.11"
					x2="183.22"
					y2="477.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.22"
					y1="477.47"
					x2="185.14"
					y2="476.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.14"
					y1="476.44"
					x2="187.68"
					y2="475.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.68"
					y1="475.95"
					x2="190.29"
					y2="475.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.29"
					y1="475.84"
					x2="191.58"
					y2="475.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.58"
					y1="475.86"
					x2="192.61"
					y2="476.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.61"
					y1="476.4"
					x2="192.91"
					y2="477.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.91"
					y1="477.04"
					x2="194.94"
					y2="484.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.94"
					y1="484.18"
					x2="195.54"
					y2="487.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.54"
					y1="487.73"
					x2="195.8"
					y2="491.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.8"
					y1="491.31"
					x2="195.8"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.41"
					y1="493.66"
					x2="242.09"
					y2="490.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.09"
					y1="490.84"
					x2="241.36"
					y2="488.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.36"
					y1="488.11"
					x2="239.97"
					y2="485.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.97"
					y1="485.21"
					x2="237.68"
					y2="482.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.68"
					y1="482.54"
					x2="234.8"
					y2="480.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.8"
					y1="480.52"
					x2="231.52"
					y2="479.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.52"
					y1="479.02"
					x2="228.04"
					y2="477.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.04"
					y1="477.94"
					x2="222.41"
					y2="476.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.41"
					y1="476.96"
					x2="219.58"
					y2="476.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.58"
					y1="476.91"
					x2="216.75"
					y2="477.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.75"
					y1="477.23"
					x2="212.37"
					y2="478.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.37"
					y1="478.5"
					x2="208.12"
					y2="480.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.12"
					y1="480.49"
					x2="204.33"
					y2="482.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.33"
					y1="482.85"
					x2="201.3"
					y2="485.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.93"
					y1="513.43"
					x2="195.58"
					y2="512.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.58"
					y1="512.98"
					x2="196.54"
					y2="511.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.54"
					y1="511.68"
					x2="196.76"
					y2="510.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.76"
					y1="510.55"
					x2="197.38"
					y2="503.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.38"
					y1="503.31"
					x2="197.66"
					y2="496.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.66"
					y1="496.04"
					x2="197.66"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.93"
					y1="473.89"
					x2="195.58"
					y2="474.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.58"
					y1="474.34"
					x2="196.54"
					y2="475.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.54"
					y1="475.64"
					x2="196.76"
					y2="476.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.76"
					y1="476.77"
					x2="197.38"
					y2="484.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.38"
					y1="484.01"
					x2="197.66"
					y2="491.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.66"
					y1="491.28"
					x2="197.66"
					y2="493.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.91"
					y1="475.26"
					x2="182.38"
					y2="475.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.38"
					y1="475.91"
					x2="181.27"
					y2="477.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.27"
					y1="477.93"
					x2="180.65"
					y2="479.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.65"
					y1="479.85"
					x2="180.33"
					y2="481.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="180.33 520.91 181.24 520.91 181.24 516.37 180.33 516.37 180.33 520.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="180.33"
					y1="516.37"
					x2="180.33"
					y2="520.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="516.37"
					x2="180.33"
					y2="516.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="520.91"
					x2="181.24"
					y2="516.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="520.91"
					x2="181.24"
					y2="520.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="180.33 466.41 180.33 470.95 181.24 470.95 181.24 466.41 180.33 466.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="181.24"
					y1="466.41"
					x2="180.33"
					y2="466.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="470.95"
					x2="181.24"
					y2="466.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="470.95"
					x2="181.24"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="466.41"
					x2="180.33"
					y2="470.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="181.24 519.1 188.63 519.1 188.63 518.19 181.24 518.19 181.24 519.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="181.24"
					y1="518.19"
					x2="181.24"
					y2="519.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.63"
					y1="518.19"
					x2="181.24"
					y2="518.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.63"
					y1="519.1"
					x2="188.63"
					y2="518.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="519.1"
					x2="188.63"
					y2="519.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="181.24 468.22 181.24 469.13 188.63 469.13 188.63 468.22 181.24 468.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="188.63"
					y1="468.22"
					x2="181.24"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.63"
					y1="469.13"
					x2="188.63"
					y2="468.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="469.13"
					x2="188.63"
					y2="469.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.24"
					y1="468.22"
					x2="181.24"
					y2="469.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="186.36 518.19 188.17 518.19 188.17 469.13 186.36 469.13 186.36 518.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="186.36"
					y1="469.13"
					x2="186.36"
					y2="518.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.17"
					y1="469.13"
					x2="186.36"
					y2="469.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.17"
					y1="518.19"
					x2="188.17"
					y2="469.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.36"
					y1="518.19"
					x2="188.17"
					y2="518.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.6 665.65 332.6 595.52 197.94 595.52 197.94 665.65 332.6 665.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.94"
					y1="665.65"
					x2="332.6"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.94"
					y1="595.52"
					x2="197.94"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="595.52"
					x2="197.94"
					y2="595.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.6"
					y1="665.65"
					x2="332.6"
					y2="595.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.41"
					y1="661.17"
					x2="328.13"
					y2="661.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.13"
					y1="661.17"
					x2="328.13"
					y2="599.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.13"
					y1="599.99"
					x2="202.41"
					y2="599.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.41"
					y1="599.99"
					x2="202.41"
					y2="661.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.41"
					y1="661.17"
					x2="258.74"
					y2="633.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.41"
					y1="599.99"
					x2="258.74"
					y2="627.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.13"
					y1="661.17"
					x2="271.8"
					y2="633.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.13"
					y1="599.99"
					x2="271.8"
					y2="627.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.27"
					y1="635.06"
					x2="265.27"
					y2="626.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.74"
					y1="630.58"
					x2="260.8"
					y2="630.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m272.42,630.58c0-3.95-3.2-7.15-7.15-7.15s-7.15,3.2-7.15,7.15,3.2,7.15,7.15,7.15,7.15-3.2,7.15-7.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m269.74,630.58c0-2.47-2-4.47-4.47-4.47s-4.47,2-4.47,4.47,2,4.47,4.47,4.47,4.47-2,4.47-4.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="197.94 630.58 207.42 637.57 207.42 623.6 197.94 630.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="207.42"
					y1="623.6"
					x2="197.94"
					y2="630.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.42"
					y1="637.57"
					x2="207.42"
					y2="623.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.94"
					y1="630.58"
					x2="207.42"
					y2="637.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.59"
					y1="630.58"
					x2="215.42"
					y2="630.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.42"
					y1="630.58"
					x2="207.42"
					y2="623.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.42"
					y1="623.6"
					x2="197.94"
					y2="630.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.42"
					y1="630.58"
					x2="207.42"
					y2="637.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.42"
					y1="637.57"
					x2="197.94"
					y2="630.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.41"
					y1="628.53"
					x2="214.46"
					y2="625.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.41"
					y1="632.64"
					x2="214.46"
					y2="635.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="582.7 595.56 582.7 647.39 633.63 647.39 633.63 595.56 582.7 595.56"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="633.63"
					y1="595.56"
					x2="631.61"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="628.33"
					y1="595.56"
					x2="622.88"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="619.61"
					y1="595.56"
					x2="614.16"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.89"
					y1="595.56"
					x2="605.44"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.17"
					y1="595.56"
					x2="596.72"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.45"
					y1="595.56"
					x2="588"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.73"
					y1="595.56"
					x2="582.7"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="647.39"
					x2="633.63"
					y2="644.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="641.65"
					x2="633.63"
					y2="636.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="632.92"
					x2="633.63"
					y2="627.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="624.21"
					x2="633.63"
					y2="618.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="615.48"
					x2="633.63"
					y2="610.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="606.76"
					x2="633.63"
					y2="601.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.63"
					y1="598.04"
					x2="633.63"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="647.39"
					x2="584.73"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="588"
					y1="647.39"
					x2="593.45"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.72"
					y1="647.39"
					x2="602.17"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.44"
					y1="647.39"
					x2="610.89"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.16"
					y1="647.39"
					x2="619.61"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.88"
					y1="647.39"
					x2="628.33"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="631.61"
					y1="647.39"
					x2="633.63"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="595.56"
					x2="582.7"
					y2="598.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="601.31"
					x2="582.7"
					y2="606.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="610.03"
					x2="582.7"
					y2="615.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="618.75"
					x2="582.7"
					y2="624.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="627.47"
					x2="582.7"
					y2="632.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="636.2"
					x2="582.7"
					y2="641.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.7"
					y1="644.92"
					x2="582.7"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="633.44 592.88 633.44 591.32 582.89 591.32 582.89 592.88 590.82 592.88 590.82 591.6 625.51 591.6 625.51 592.88 633.44 592.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="625.51"
					y1="592.88"
					x2="633.44"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="625.51"
					y1="591.6"
					x2="625.51"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="590.82"
					y1="591.6"
					x2="625.51"
					y2="591.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="590.82"
					y1="592.88"
					x2="590.82"
					y2="591.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="582.89"
					y1="592.88"
					x2="590.82"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="582.89"
					y1="591.32"
					x2="582.89"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="633.44"
					y1="591.32"
					x2="582.89"
					y2="591.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="633.44"
					y1="592.88"
					x2="633.44"
					y2="591.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="635.42 592.88 580.91 592.88 580.91 595.56 635.42 595.56 635.42 592.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="635.42"
					y1="595.56"
					x2="635.42"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="580.91"
					y1="595.56"
					x2="635.42"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="580.91"
					y1="592.88"
					x2="580.91"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="635.42"
					y1="592.88"
					x2="580.91"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="582.89"
					y1="592.88"
					x2="582.89"
					y2="591.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.89"
					y1="591.32"
					x2="633.44"
					y2="591.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.44"
					y1="591.32"
					x2="633.44"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.91"
					y1="592.88"
					x2="635.42"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.51"
					y1="592.88"
					x2="625.51"
					y2="591.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="625.51"
					y1="591.6"
					x2="590.82"
					y2="591.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.82"
					y1="591.6"
					x2="590.82"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.91"
					y1="595.56"
					x2="580.91"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.42"
					y1="592.88"
					x2="635.42"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.42"
					y1="595.56"
					x2="580.91"
					y2="595.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="343.96 584.92 419.22 584.92 419.22 665.65 343.96 665.65 343.96 584.92"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="343.96"
					y1="584.92"
					x2="419.22"
					y2="584.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.22"
					y1="584.92"
					x2="419.22"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.22"
					y1="665.65"
					x2="343.96"
					y2="665.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="665.65"
					x2="343.96"
					y2="584.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="590.6"
					x2="419.22"
					y2="590.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="574.15 599.41 517.58 599.41 516.31 599.94 515.79 601.2 515.79 639.07 516.31 640.34 517.58 640.86 574.15 640.86 575.42 640.34 575.94 639.07 575.94 601.2 575.42 599.94 574.15 599.41"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m574.15,599.41c.99,0,1.79.8,1.79,1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.94"
					y1="639.07"
					x2="575.94"
					y2="601.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m575.94,639.07c0,.99-.8,1.79-1.79,1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.58"
					y1="640.86"
					x2="574.15"
					y2="640.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m517.58,640.86c-.99,0-1.79-.8-1.79-1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="515.79"
					y1="601.2"
					x2="515.79"
					y2="639.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m515.79,601.2c0-.99.8-1.79,1.79-1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.15"
					y1="599.41"
					x2="517.58"
					y2="599.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.68"
					y1="603.88"
					x2="522.05"
					y2="603.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.26"
					y1="605.67"
					x2="520.26"
					y2="630.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="522.05"
					y1="631.92"
					x2="569.68"
					y2="631.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.47"
					y1="630.13"
					x2="571.47"
					y2="605.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.68"
					y1="603.88"
					x2="569.68"
					y2="603.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m520.26,605.67c0-.99.8-1.79,1.79-1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m522.05,631.92c-.99,0-1.79-.8-1.79-1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m571.47,630.13c0,.99-.8,1.79-1.79,1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m569.68,603.88c.99,0,1.79.8,1.79,1.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m548.55,622.98c0-1.48-1.2-2.68-2.68-2.68s-2.68,1.2-2.68,2.68,1.2,2.68,2.68,2.68,2.68-1.2,2.68-2.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="546.67 620.48 546.43 619.92 545.86 619.68 545.29 619.92 545.06 620.49 545.06 638.18 545.3 638.75 545.86 638.98 546.43 638.75 546.67 638.18 546.67 620.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="546.67"
					y1="638.18"
					x2="546.67"
					y2="620.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m546.67,638.18c0,.45-.36.8-.8.8s-.8-.36-.8-.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.06"
					y1="620.49"
					x2="545.06"
					y2="638.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m545.06,620.49h0c0-.45.36-.8.8-.8s.8.36.8.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="547.65 633.62 546.67 633.62 546.67 638.18 546.43 638.75 545.86 638.98 545.3 638.75 545.06 638.18 545.06 633.62 544.08 633.62 544.08 639.43 547.65 639.43 547.65 633.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="547.65"
					y1="639.43"
					x2="547.65"
					y2="633.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.08"
					y1="639.43"
					x2="547.65"
					y2="639.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.08"
					y1="633.62"
					x2="544.08"
					y2="639.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.06"
					y1="633.62"
					x2="544.08"
					y2="633.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.06"
					y1="638.18"
					x2="545.06"
					y2="633.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m546.67,638.18c0,.45-.36.8-.8.8s-.8-.36-.8-.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.67"
					y1="633.62"
					x2="546.67"
					y2="638.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.65"
					y1="633.62"
					x2="546.67"
					y2="633.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="547.63 630.4 546.67 630.4 546.67 633.53 547.63 633.53 547.63 630.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="547.63"
					y1="633.53"
					x2="547.63"
					y2="630.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.67"
					y1="633.53"
					x2="547.63"
					y2="633.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.67"
					y1="630.4"
					x2="546.67"
					y2="633.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="547.63"
					y1="630.4"
					x2="546.67"
					y2="630.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="544.1 630.4 544.1 633.53 545.06 633.53 545.06 630.4 544.1 630.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="545.06"
					y1="630.4"
					x2="544.1"
					y2="630.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.06"
					y1="633.53"
					x2="545.06"
					y2="630.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="633.53"
					x2="545.06"
					y2="633.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.1"
					y1="630.4"
					x2="544.1"
					y2="633.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="225.73 591.62 225.73 532.57 180.33 532.57 180.33 591.62 225.73 591.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.73"
					y1="591.62"
					x2="225.73"
					y2="532.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.33"
					y1="591.62"
					x2="180.33"
					y2="532.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.73"
					y1="532.57"
					x2="180.33"
					y2="532.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.73"
					y1="591.62"
					x2="180.33"
					y2="591.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.12"
					y1="591.62"
					x2="182.12"
					y2="532.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.95"
					y1="584.81"
					x2="214.95"
					y2="539.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.95"
					y1="539.38"
					x2="187.7"
					y2="539.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.7"
					y1="539.38"
					x2="187.7"
					y2="584.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.7"
					y1="584.81"
					x2="214.95"
					y2="584.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.74"
					y1="586.59"
					x2="216.74"
					y2="537.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.74"
					y1="537.59"
					x2="185.91"
					y2="537.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.91"
					y1="537.59"
					x2="185.91"
					y2="586.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.91"
					y1="586.59"
					x2="216.74"
					y2="586.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m196.53,562.09c0-1.48-1.2-2.68-2.68-2.68s-2.68,1.2-2.68,2.68,1.2,2.68,2.68,2.68,2.68-1.2,2.68-2.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="182.78 564.33 186.53 563.97 187.38 563.68 192.12 563.08 192.74 562.75 192.99 562.09 192.74 561.43 192.12 561.1 187.38 560.51 186.53 560.21 182.78 559.85 181.47 560.28 180.65 561.4 180.65 562.78 181.47 563.9 182.78 564.33"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m182.78,564.33c-1.23,0-2.24-1-2.24-2.23s1-2.24,2.24-2.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.53"
					y1="560.21"
					x2="182.78"
					y2="559.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m186.53,560.21c.3.03.59.13.85.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="192.12"
					y1="561.1"
					x2="187.38"
					y2="560.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m192.12,561.1c.5.06.88.49.88.99s-.38.93-.88.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.38"
					y1="563.68"
					x2="192.12"
					y2="563.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m187.38,563.68c-.26.17-.55.27-.85.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.78"
					y1="564.33"
					x2="186.53"
					y2="563.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.01"
					y1="560.88"
					x2="186.34"
					y2="560.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.34"
					y1="563.31"
					x2="185.01"
					y2="563.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.01"
					y1="563.31"
					x2="185.01"
					y2="560.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m186.34,560.88c.67,0,1.22.55,1.22,1.22s-.54,1.21-1.22,1.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m187.38,560.51c.54.35.86.94.86,1.59s-.33,1.24-.86,1.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.65"
					y1="435.77"
					x2="777.11"
					y2="435.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.11"
					y1="435.77"
					x2="777.11"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.65"
					y1="444.09"
					x2="791.65"
					y2="387.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.06"
					y1="387.97"
					x2="829.06"
					y2="444.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.06"
					y1="444.09"
					x2="772.95"
					y2="444.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.95"
					y1="387.97"
					x2="829.06"
					y2="387.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.99"
					y1="444.09"
					x2="773.99"
					y2="387.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.65"
					y1="396.28"
					x2="777.11"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.95"
					y1="444.09"
					x2="772.95"
					y2="387.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.51"
					y1="592.88"
					x2="419.22"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.72"
					y1="584.92"
					x2="416.72"
					y2="579.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.72"
					y1="579.96"
					x2="414.21"
					y2="579.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.21"
					y1="579.96"
					x2="414.21"
					y2="584.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.96"
					y1="592.88"
					x2="349.43"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.7"
					y1="592.88"
					x2="358.15"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.42"
					y1="592.88"
					x2="366.87"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.14"
					y1="592.88"
					x2="375.59"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.86"
					y1="592.88"
					x2="384.32"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.59"
					y1="592.88"
					x2="393.04"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.31"
					y1="592.88"
					x2="401.76"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.03"
					y1="592.88"
					x2="410.48"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.75"
					y1="592.88"
					x2="419.22"
					y2="592.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.51"
					y1="592.88"
					x2="636.51"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357"
					y1="50"
					x2="206.1"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.1"
					y1="68.17"
					x2="357"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.37"
					y1="50"
					x2="657.33"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.33"
					y1="68.17"
					x2="479.37"
					y2="68.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.83"
					y1="435.77"
					x2="822.83"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.83"
					y1="396.28"
					x2="795.81"
					y2="396.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.81"
					y1="396.28"
					x2="795.81"
					y2="435.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.81"
					y1="435.77"
					x2="822.83"
					y2="435.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="510.82 588.34 442.68 588.34 442.68 647.39 510.82 647.39 510.82 588.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="510.82"
					y1="588.34"
					x2="442.68"
					y2="588.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.82"
					y1="647.39"
					x2="442.68"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.82"
					y1="645.6"
					x2="442.68"
					y2="645.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="510.82"
					y1="588.34"
					x2="510.82"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="442.68"
					y1="588.34"
					x2="442.68"
					y2="647.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.34"
					y1="591.02"
					x2="447.15"
					y2="591.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.15"
					y1="591.02"
					x2="445.36"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.36"
					y1="592.81"
					x2="445.36"
					y2="642.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.36"
					y1="642.92"
					x2="447.15"
					y2="644.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.15"
					y1="644.71"
					x2="506.34"
					y2="644.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.34"
					y1="644.71"
					x2="508.13"
					y2="642.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.13"
					y1="642.92"
					x2="508.13"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.13"
					y1="592.81"
					x2="506.34"
					y2="591.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m502.72,603.1c0-4.94-4-8.94-8.94-8.94s-8.94,4-8.94,8.94,4,8.94,8.94,8.94,8.94-4,8.94-8.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m500.49,632.63c0-3.7-3-6.71-6.71-6.71s-6.7,3-6.7,6.71,3,6.71,6.7,6.71,6.71-3,6.71-6.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m466.42,603.1c0-3.7-3-6.7-6.71-6.7s-6.7,3-6.7,6.7,3,6.71,6.7,6.71,6.71-3,6.71-6.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m468.65,632.63c0-4.94-4-8.94-8.94-8.94s-8.94,4-8.94,8.94,4,8.94,8.94,8.94,8.94-4,8.94-8.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="636.51"
					y1="620.14"
					x2="634.16"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.89"
					y1="620.14"
					x2="625.44"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.17"
					y1="620.14"
					x2="616.72"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="613.45"
					y1="620.14"
					x2="607.99"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="604.72"
					y1="620.14"
					x2="599.27"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596"
					y1="620.14"
					x2="590.55"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.28"
					y1="620.14"
					x2="581.83"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.56"
					y1="620.14"
					x2="573.11"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.84"
					y1="620.14"
					x2="564.39"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.12"
					y1="620.14"
					x2="555.66"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.39"
					y1="620.14"
					x2="546.94"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.67"
					y1="620.14"
					x2="538.22"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.95"
					y1="620.14"
					x2="529.5"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.23"
					y1="620.14"
					x2="520.78"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.51"
					y1="620.14"
					x2="512.06"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.79"
					y1="620.14"
					x2="503.33"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.07"
					y1="620.14"
					x2="494.62"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.34"
					y1="620.14"
					x2="485.89"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.62"
					y1="620.14"
					x2="477.17"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.9"
					y1="620.14"
					x2="468.45"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.18"
					y1="620.14"
					x2="459.73"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.46"
					y1="620.14"
					x2="451.01"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="447.74"
					y1="620.14"
					x2="442.29"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.01"
					y1="620.14"
					x2="433.56"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.29"
					y1="620.14"
					x2="424.84"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.57"
					y1="620.14"
					x2="419.22"
					y2="620.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="479.37 50 479.37 68.17 444.29 68.17 444.29 452.89 426.42 452.89 426.42 441.55 432.94 441.55 432.94 141.17 385.61 141.17 385.61 68.17 357 68.17 357 50 479.37 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.15"
				/>
				<polygon
					points="861.16 354.9 861.16 713.79 818.18 713.79 818.18 948.87 780.69 948.87 780.69 930.69 800.02 930.69 800.02 794.01 779.48 794.01 779.48 685.27 790.84 685.27 790.84 695.62 842.98 695.62 842.98 614.53 790.84 614.53 790.84 626.22 779.48 626.22 779.48 614.53 755.71 614.53 755.71 447.85 767.06 447.85 767.06 459.05 842.98 459.05 842.98 373.07 767.06 373.07 767.06 384.26 755.71 384.26 755.71 373.07 728.52 373.07 728.52 92.06 666.73 92.06 666.73 68.17 657.33 68.17 657.33 50 746.69 50 746.69 354.9 861.16 354.9"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.15"
				/>
				<polygon
					points="694.38 930.69 694.38 948.87 659.98 948.87 659.98 683.81 138.84 683.81 138.84 50 206.1 50 206.1 68.17 201.61 68.17 201.61 109.71 157.02 109.71 157.02 379.4 169.43 379.4 169.43 390.76 157.02 390.76 157.02 441.55 290.31 441.55 290.31 390.76 279.58 390.76 279.58 379.4 301.67 379.4 301.67 441.55 349.2 441.55 349.2 452.89 343.95 452.89 343.95 464.21 332.6 464.21 332.6 452.89 180.33 452.89 180.33 595.52 197.94 595.52 197.94 665.65 332.6 665.65 332.6 541.43 343.95 541.43 343.95 665.65 419.23 665.65 419.23 647.39 636.5 647.39 636.5 665.65 678.16 665.65 678.16 930.69 694.38 930.69"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.15"
				/>
			</g>
			<g id="text">
				<path d="m597.04,638.77v-10.53h3.63c.82,0,1.44.05,1.88.15.6.14,1.12.39,1.54.75.56.47.97,1.07,1.24,1.8.28.73.42,1.56.42,2.5,0,.8-.09,1.51-.28,2.13-.19.62-.43,1.13-.72,1.54-.29.4-.61.72-.96.96-.34.23-.76.4-1.26.52-.49.12-1.05.18-1.69.18h-3.8Zm1.39-1.24h2.25c.69,0,1.24-.06,1.63-.19.4-.13.71-.31.95-.55.33-.33.59-.77.77-1.33.19-.56.28-1.24.28-2.03,0-1.1-.18-1.95-.55-2.54-.36-.59-.8-.99-1.31-1.19-.37-.14-.97-.22-1.8-.22h-2.21v8.05Zm11.08,1.24l-2.79-10.53h1.43l1.6,6.9c.17.72.32,1.44.45,2.16.27-1.13.43-1.77.47-1.95l2-7.11h1.68l1.51,5.33c.38,1.32.65,2.56.82,3.73.13-.67.31-1.43.52-2.29l1.65-6.77h1.4l-2.89,10.53h-1.34l-2.22-8.03c-.19-.67-.3-1.08-.33-1.24-.11.48-.21.9-.31,1.24l-2.23,8.03h-1.42Z" />
				<path d="m378.26,631.6h-1.48l-1.77-2.97c-.16-.28-.32-.51-.47-.7-.15-.2-.31-.36-.47-.48-.16-.12-.33-.21-.52-.27-.18-.06-.39-.09-.62-.09h-1.02v4.51h-1.24v-10.6h3.16c.46,0,.89.06,1.28.18.39.11.73.29,1.02.52.29.24.52.53.68.89.16.35.24.76.24,1.23,0,.37-.06.71-.17,1.02-.11.31-.27.58-.47.82-.2.24-.45.45-.74.62-.29.17-.61.3-.97.39v.03c.18.08.33.17.46.27.13.1.26.22.38.35.12.14.23.3.35.47.12.17.25.37.39.61l1.99,3.19Zm-6.36-9.48v3.85h1.69c.31,0,.6-.05.86-.14.27-.09.5-.23.69-.4.19-.18.34-.39.45-.64.11-.26.16-.54.16-.86,0-.57-.18-1.01-.55-1.32-.36-.32-.89-.48-1.59-.48h-1.7Zm13.6,6h-5.35c.02.84.25,1.49.68,1.95.43.46,1.03.69,1.79.69.85,0,1.64-.28,2.35-.84v1.14c-.67.48-1.55.72-2.64.72s-1.91-.34-2.52-1.03c-.61-.69-.92-1.66-.92-2.91,0-1.18.33-2.14,1-2.88.67-.74,1.5-1.12,2.49-1.12s1.76.32,2.3.96c.54.64.81,1.53.81,2.67v.64Zm-1.24-1.03c0-.7-.18-1.24-.51-1.63-.33-.39-.79-.58-1.38-.58s-1.06.2-1.46.61-.65.94-.74,1.6h4.09Zm6.68-5.63c-.24-.13-.51-.2-.81-.2-.85,0-1.27.53-1.27,1.6v1.17h1.77v1.04h-1.77v6.54h-1.21v-6.54h-1.29v-1.04h1.29v-1.23c0-.79.23-1.42.69-1.88.46-.46,1.03-.7,1.72-.7.37,0,.66.04.88.13v1.09Z" />
				<path d="m392.23,631.76c-.23,0-.42-.08-.58-.24-.16-.16-.24-.36-.24-.58s.08-.42.24-.58c.16-.17.36-.25.58-.25s.43.08.59.25c.16.16.24.36.24.58s-.08.42-.24.58c-.16.16-.36.24-.59.24Z" />
				<path d="m257.97,565.21v-16.47h4.69c1.42,0,2.55.35,3.39,1.05.83.7,1.25,1.6,1.25,2.72,0,.93-.25,1.75-.76,2.43-.51.69-1.2,1.18-2.09,1.47v.05c1.11.13,2,.55,2.66,1.26.67.7,1,1.62,1,2.76,0,1.41-.51,2.55-1.52,3.42-1.01.87-2.29,1.31-3.82,1.31h-4.8Zm1.93-14.72v5.32h1.98c1.06,0,1.89-.25,2.49-.76.6-.51.91-1.23.91-2.16,0-1.6-1.05-2.4-3.16-2.4h-2.22Zm0,7.05v5.93h2.62c1.13,0,2.01-.27,2.63-.8.63-.54.94-1.27.94-2.21,0-1.94-1.32-2.92-3.97-2.92h-2.22Zm19.71,7.67h-1.88v-1.84h-.05c-.82,1.41-2.03,2.11-3.62,2.11-1.17,0-2.09-.31-2.76-.93-.66-.62-.99-1.44-.99-2.47,0-2.2,1.29-3.48,3.88-3.84l3.53-.49c0-2-.81-3-2.42-3-1.42,0-2.7.48-3.84,1.45v-1.93c1.16-.74,2.49-1.1,4-1.1,2.76,0,4.15,1.46,4.15,4.39v7.65Zm-1.88-5.95l-2.84.39c-.87.12-1.53.34-1.98.65-.44.31-.67.85-.67,1.64,0,.57.2,1.05.61,1.41.41.36.96.54,1.64.54.93,0,1.7-.33,2.31-.98.61-.66.92-1.49.92-2.49v-1.17Zm10.89,5.83c-.44.24-1.03.37-1.76.37-2.06,0-3.09-1.15-3.09-3.45v-6.96h-2.02v-1.61h2.02v-2.87l1.88-.61v3.48h2.96v1.61h-2.96v6.63c0,.79.13,1.35.4,1.69.27.34.71.51,1.33.51.47,0,.88-.13,1.23-.39v1.61Zm12.28.11h-1.88v-6.78c0-2.45-.91-3.68-2.73-3.68-.92,0-1.69.36-2.32,1.07-.63.7-.94,1.61-.94,2.72v6.66h-1.88v-17.41h1.88v7.6h.05c.9-1.49,2.19-2.23,3.86-2.23,2.65,0,3.97,1.6,3.97,4.79v7.25Z" />
				<path d="m723.56,856.47h-8.73v-16.47h8.36v1.75h-6.43v5.48h5.95v1.73h-5.95v5.77h6.8v1.75Zm12.7,0h-1.88v-6.71c0-2.5-.91-3.74-2.73-3.74-.94,0-1.72.36-2.34,1.07-.61.7-.92,1.6-.92,2.68v6.71h-1.88v-11.76h1.88v1.95h.05c.89-1.49,2.17-2.23,3.86-2.23,1.29,0,2.27.42,2.95,1.25.68.83,1.02,2.03,1.02,3.59v7.19Zm9.02-.11c-.44.24-1.03.37-1.76.37-2.06,0-3.09-1.15-3.09-3.45v-6.96h-2.02v-1.61h2.02v-2.87l1.88-.61v3.48h2.96v1.61h-2.96v6.63c0,.79.13,1.35.4,1.69.27.34.71.51,1.33.51.47,0,.88-.13,1.23-.39v1.61Zm8.67-9.74c-.33-.25-.8-.38-1.42-.38-.8,0-1.48.38-2.02,1.14-.54.76-.8,1.79-.8,3.1v6h-1.88v-11.76h1.88v2.42h.05c.27-.83.68-1.47,1.23-1.93.55-.47,1.17-.7,1.85-.7.49,0,.87.05,1.13.16v1.95Zm11.43-1.91l-5.41,13.64c-.96,2.43-2.32,3.65-4.07,3.65-.49,0-.9-.05-1.23-.15v-1.69c.41.14.78.21,1.11.21.95,0,1.66-.57,2.14-1.7l.94-2.23-4.59-11.74h2.09l3.18,9.05c.04.11.12.41.24.9h.07c.04-.18.11-.47.23-.87l3.34-9.07h1.95Z" />
				<path d="m249.4,253.25v-16.47h4.69c1.42,0,2.55.35,3.39,1.05s1.25,1.6,1.25,2.72c0,.93-.25,1.75-.76,2.43-.51.69-1.2,1.18-2.09,1.47v.05c1.11.13,2,.55,2.66,1.26.67.7,1,1.62,1,2.76,0,1.41-.51,2.55-1.52,3.42-1.01.87-2.29,1.31-3.82,1.31h-4.8Zm1.93-14.72v5.32h1.98c1.06,0,1.89-.25,2.49-.76.6-.51.91-1.23.91-2.16,0-1.6-1.05-2.4-3.16-2.4h-2.22Zm0,7.05v5.93h2.62c1.13,0,2.01-.27,2.63-.8.63-.54.94-1.27.94-2.21,0-1.94-1.32-2.92-3.97-2.92h-2.22Zm20.72,2.26h-8.3c.03,1.31.38,2.32,1.06,3.03.67.71,1.6,1.07,2.78,1.07,1.32,0,2.54-.44,3.65-1.31v1.77c-1.03.75-2.4,1.13-4.1,1.13s-2.97-.53-3.92-1.6c-.95-1.07-1.42-2.58-1.42-4.51,0-1.83.52-3.32,1.55-4.47,1.04-1.16,2.33-1.73,3.87-1.73s2.73.5,3.57,1.49c.84,1,1.26,2.38,1.26,4.15v.99Zm-1.93-1.6c0-1.09-.27-1.93-.79-2.54-.51-.6-1.23-.91-2.15-.91s-1.64.32-2.26.95c-.62.64-1,1.47-1.15,2.49h6.35Zm14.79,7.01h-1.88v-2h-.05c-.87,1.52-2.22,2.27-4.04,2.27-1.48,0-2.66-.52-3.55-1.57-.88-1.06-1.32-2.49-1.32-4.31,0-1.94.49-3.5,1.47-4.67.98-1.17,2.29-1.76,3.92-1.76s2.79.64,3.53,1.91h.05v-7.28h1.88v17.41Zm-1.88-5.32v-1.73c0-.95-.31-1.75-.94-2.41s-1.42-.99-2.39-.99c-1.15,0-2.05.42-2.71,1.26-.66.84-.99,2.01-.99,3.49,0,1.36.31,2.43.94,3.22.64.78,1.49,1.17,2.55,1.17s1.9-.38,2.55-1.14c.66-.76.99-1.72.99-2.87Zm11.81-4.54c-.33-.25-.8-.38-1.42-.38-.8,0-1.48.38-2.02,1.14-.54.76-.8,1.79-.8,3.1v6h-1.88v-11.76h1.88v2.42h.05c.27-.83.68-1.47,1.23-1.93.55-.47,1.17-.7,1.85-.7.49,0,.87.05,1.13.16v1.95Zm6.95,10.13c-1.74,0-3.13-.55-4.17-1.64-1.03-1.1-1.55-2.56-1.55-4.38,0-1.98.54-3.52,1.62-4.63,1.08-1.11,2.54-1.67,4.38-1.67s3.12.54,4.1,1.62c.99,1.08,1.48,2.58,1.48,4.49s-.53,3.38-1.6,4.51c-1.06,1.13-2.48,1.69-4.26,1.69Zm.14-10.73c-1.21,0-2.17.41-2.87,1.24-.7.82-1.06,1.95-1.06,3.4s.36,2.49,1.07,3.3,1.67,1.21,2.86,1.21,2.15-.39,2.8-1.18c.66-.79.99-1.91.99-3.37s-.33-2.6-.99-3.4c-.65-.8-1.58-1.19-2.8-1.19Zm13.62,10.73c-1.74,0-3.13-.55-4.17-1.64-1.03-1.1-1.55-2.56-1.55-4.38,0-1.98.54-3.52,1.62-4.63,1.08-1.11,2.54-1.67,4.38-1.67s3.12.54,4.1,1.62c.99,1.08,1.48,2.58,1.48,4.49s-.53,3.38-1.6,4.51c-1.06,1.13-2.48,1.69-4.26,1.69Zm.14-10.73c-1.21,0-2.17.41-2.87,1.24-.7.82-1.06,1.95-1.06,3.4s.36,2.49,1.07,3.3,1.67,1.21,2.86,1.21,2.15-.39,2.8-1.18c.66-.79.99-1.91.99-3.37s-.33-2.6-.99-3.4c-.65-.8-1.59-1.19-2.8-1.19Zm25.41,10.45h-1.88v-6.75c0-1.3-.2-2.24-.61-2.83-.4-.58-1.07-.87-2.02-.87-.8,0-1.49.37-2.06,1.1-.56.74-.84,1.62-.84,2.64v6.71h-1.88v-6.98c0-2.31-.89-3.47-2.68-3.47-.83,0-1.51.35-2.04,1.05-.54.69-.8,1.59-.8,2.7v6.71h-1.88v-11.76h1.88v1.86h.05c.83-1.42,2.05-2.14,3.65-2.14.8,0,1.5.23,2.1.68.6.44,1.01,1.03,1.23,1.76.87-1.62,2.17-2.43,3.9-2.43,2.59,0,3.88,1.6,3.88,4.79v7.25Z" />
				<path d="m254.11,277.66h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Zm11.71-6.04c0,1-.09,1.89-.28,2.66-.18.77-.44,1.43-.78,1.96-.34.53-.76.93-1.26,1.21-.5.27-1.06.41-1.69.41-.6,0-1.14-.13-1.61-.39-.47-.27-.86-.65-1.19-1.16-.32-.51-.57-1.13-.73-1.86-.17-.74-.25-1.59-.25-2.54,0-1.05.09-1.97.26-2.77.18-.8.44-1.47.78-2.01.34-.55.76-.95,1.26-1.23.51-.28,1.09-.42,1.74-.42,2.51,0,3.76,2.05,3.76,6.14Zm-1.4.13c0-3.41-.81-5.11-2.43-5.11-1.71,0-2.56,1.73-2.56,5.2,0,3.23.84,4.85,2.51,4.85s2.48-1.65,2.48-4.94Z" />
				<rect x="267.89" y="265.69" width="1.21" height="3.73" />
				<path d="m276.45,277.66h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Z" />
				<path d="m282.22,265.69v3.73h-1.21v-3.73h1.21Zm2.77,0v3.73h-1.21v-3.73h1.21Z" />
				<path d="m298.67,269.11l-2.87,4.32,2.82,4.22h-1.59l-1.68-2.77c-.11-.17-.23-.39-.38-.65h-.03c-.03.05-.16.27-.39.65l-1.71,2.77h-1.58l2.91-4.19-2.79-4.36h1.59l1.65,2.92c.12.22.24.44.36.67h.03l2.14-3.59h1.51Z" />
				<path d="m309.63,277.66h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Zm9.23,0h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Z" />
				<rect x="323.42" y="265.69" width="1.21" height="3.73" />
				<path d="m334.02,274c0,.58-.1,1.11-.3,1.59s-.49.88-.86,1.22c-.37.34-.81.6-1.34.78-.52.18-1.1.28-1.74.28-1.11,0-1.94-.17-2.48-.5v-1.45c.81.52,1.64.78,2.5.78.43,0,.82-.06,1.17-.19.35-.13.65-.31.89-.53.24-.23.43-.5.56-.83.13-.32.2-.68.2-1.06,0-.78-.26-1.39-.78-1.83-.52-.45-1.28-.67-2.28-.67-.16,0-.33,0-.51,0s-.36.01-.53.02c-.18,0-.35.01-.53.03-.17.01-.32.03-.46.04l.41-6h5.53v1.24h-4.35l-.24,3.51c.18-.01.37-.02.57-.02.2-.01.38-.02.53-.02.63,0,1.2.08,1.7.25.5.17.92.41,1.27.72.35.31.61.68.79,1.14.18.45.28.95.28,1.5Z" />
				<path d="m337.74,265.69v3.73h-1.21v-3.73h1.21Zm2.77,0v3.73h-1.21v-3.73h1.21Z" />
				<path d="m465.37,548.36h-2.69l-6.36-7.53c-.24-.28-.38-.47-.44-.57h-.05v8.11h-1.93v-16.47h1.93v7.74h.05c.11-.17.25-.36.44-.56l6.16-7.18h2.4l-7.06,7.9,7.56,8.57Zm2.87-14.75c-.34,0-.62-.11-.86-.34s-.36-.52-.36-.87.12-.64.36-.87c.24-.24.52-.36.86-.36s.64.12.87.36c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.36-.87.36Zm.92,14.75h-1.88v-11.76h1.88v11.76Zm9.25-.11c-.44.25-1.03.37-1.76.37-2.06,0-3.09-1.15-3.09-3.45v-6.96h-2.02v-1.61h2.02v-2.87l1.88-.61v3.48h2.96v1.61h-2.96v6.63c0,.79.13,1.35.4,1.69.27.34.71.51,1.33.51.47,0,.88-.13,1.23-.39v1.61Zm10.52-.42c-.9.54-1.98.82-3.22.82-1.68,0-3.03-.54-4.07-1.63-1.03-1.09-1.54-2.51-1.54-4.25,0-1.94.56-3.49,1.67-4.66,1.11-1.18,2.59-1.77,4.44-1.77,1.03,0,1.94.19,2.73.57v1.93c-.87-.61-1.81-.92-2.8-.92-1.2,0-2.19.43-2.96,1.3-.77.86-1.15,1.99-1.15,3.39s.36,2.47,1.08,3.26c.73.8,1.7,1.19,2.92,1.19,1.03,0,1.99-.34,2.89-1.02v1.79Zm12.59.54h-1.88v-6.78c0-2.45-.91-3.68-2.73-3.68-.92,0-1.69.36-2.32,1.07-.63.7-.94,1.61-.94,2.72v6.66h-1.88v-17.41h1.88v7.6h.05c.9-1.49,2.19-2.23,3.86-2.23,2.65,0,3.97,1.6,3.97,4.79v7.25Zm12.98-5.41h-8.3c.03,1.31.38,2.32,1.06,3.03.67.71,1.6,1.07,2.78,1.07,1.32,0,2.54-.44,3.65-1.31v1.77c-1.03.75-2.4,1.13-4.1,1.13s-2.97-.53-3.92-1.6c-.95-1.07-1.42-2.58-1.42-4.51,0-1.83.52-3.32,1.55-4.47,1.04-1.16,2.33-1.73,3.87-1.73s2.73.5,3.57,1.49c.84,1,1.26,2.38,1.26,4.15v.99Zm-1.93-1.6c0-1.09-.27-1.93-.79-2.54-.51-.6-1.23-.91-2.15-.91s-1.64.32-2.26.95c-.62.64-1,1.47-1.15,2.49h6.35Zm14.52,7.01h-1.88v-6.71c0-2.5-.91-3.74-2.73-3.74-.94,0-1.72.36-2.34,1.07-.61.7-.92,1.6-.92,2.68v6.71h-1.88v-11.76h1.88v1.95h.05c.89-1.49,2.17-2.23,3.86-2.23,1.29,0,2.27.42,2.95,1.25.68.83,1.02,2.03,1.02,3.59v7.19Z" />
				<path d="m494.2,258.93h-8.54v-16.47h1.93v14.72h6.62v1.75Zm3.23-14.75c-.34,0-.62-.11-.86-.34-.24-.23-.36-.52-.36-.87s.12-.64.36-.87c.24-.24.52-.36.86-.36s.64.12.87.36c.25.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.36-.87.36Zm.92,14.75h-1.88v-11.76h1.88v11.76Zm13.04-11.76l-4.69,11.76h-1.85l-4.46-11.76h2.07l2.99,8.54c.22.63.36,1.18.41,1.64h.05c.08-.59.2-1.12.37-1.6l3.12-8.59h1.99Zm2.97-2.99c-.34,0-.62-.11-.86-.34-.24-.23-.36-.52-.36-.87s.12-.64.36-.87c.24-.24.52-.36.86-.36s.64.12.87.36c.25.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.36-.87.36Zm.92,14.75h-1.88v-11.76h1.88v11.76Zm13.56,0h-1.88v-6.71c0-2.5-.91-3.74-2.73-3.74-.94,0-1.72.36-2.34,1.07-.61.7-.92,1.6-.92,2.68v6.71h-1.88v-11.76h1.88v1.95h.05c.89-1.49,2.17-2.23,3.86-2.23,1.29,0,2.27.42,2.95,1.25.68.83,1.02,2.03,1.02,3.59v7.19Zm13.58-.94c0,4.32-2.07,6.48-6.2,6.48-1.45,0-2.73-.28-3.81-.83v-1.88c1.32.74,2.59,1.1,3.79,1.1,2.89,0,4.34-1.54,4.34-4.62v-1.29h-.05c-.9,1.5-2.24,2.25-4.04,2.25-1.46,0-2.64-.52-3.54-1.56-.89-1.05-1.33-2.45-1.33-4.22,0-2,.48-3.59,1.44-4.77.96-1.18,2.28-1.77,3.95-1.77s2.76.64,3.53,1.91h.05v-1.63h1.88v10.82Zm-1.88-4.38v-1.73c0-.93-.32-1.73-.95-2.4-.63-.67-1.41-1-2.35-1-1.16,0-2.07.42-2.73,1.27-.66.84-.99,2.03-.99,3.55,0,1.31.31,2.36.94,3.15.64.78,1.47,1.17,2.52,1.17s1.91-.38,2.57-1.13c.67-.75,1-1.71,1-2.88Z" />
				<polygon points="553.65 242.46 545.75 261.66 543.99 261.66 551.87 242.46 553.65 242.46" />
				<path d="m555.57,258.93v-16.47h4.55c5.8,0,8.71,2.68,8.71,8.03,0,2.54-.81,4.59-2.42,6.13-1.61,1.54-3.76,2.31-6.47,2.31h-4.36Zm1.93-14.72v12.98h2.46c2.16,0,3.84-.58,5.04-1.73,1.2-1.16,1.8-2.79,1.8-4.92,0-4.22-2.24-6.33-6.73-6.33h-2.57Zm15.19-.02c-.34,0-.62-.11-.86-.34s-.36-.52-.36-.87.12-.64.36-.87c.24-.24.52-.36.86-.36s.64.12.87.36c.25.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.36-.87.36Zm.92,14.75h-1.88v-11.76h1.88v11.76Zm13.5,0h-1.88v-6.71c0-2.5-.91-3.74-2.73-3.74-.94,0-1.72.36-2.34,1.07-.61.7-.92,1.6-.92,2.68v6.71h-1.88v-11.76h1.88v1.95h.05c.89-1.49,2.17-2.23,3.86-2.23,1.29,0,2.27.42,2.95,1.25.68.83,1.02,2.03,1.02,3.59v7.19Zm4.44-14.75c-.34,0-.62-.11-.86-.34-.24-.23-.36-.52-.36-.87s.12-.64.36-.87c.24-.24.52-.36.86-.36s.64.12.87.36c.25.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.36-.87.36Zm.92,14.75h-1.88v-11.76h1.88v11.76Zm13.5,0h-1.88v-6.71c0-2.5-.91-3.74-2.73-3.74-.94,0-1.72.36-2.34,1.07-.61.7-.92,1.6-.92,2.68v6.71h-1.88v-11.76h1.88v1.95h.05c.89-1.49,2.17-2.23,3.86-2.23,1.29,0,2.27.42,2.95,1.25.68.83,1.02,2.03,1.02,3.59v7.19Zm13.51-.94c0,4.32-2.07,6.48-6.2,6.48-1.45,0-2.73-.28-3.81-.83v-1.88c1.32.74,2.59,1.1,3.79,1.1,2.89,0,4.34-1.54,4.34-4.62v-1.29h-.05c-.9,1.5-2.24,2.25-4.04,2.25-1.46,0-2.64-.52-3.54-1.56-.89-1.05-1.33-2.45-1.33-4.22,0-2,.48-3.59,1.44-4.77.96-1.18,2.28-1.77,3.95-1.77s2.76.64,3.53,1.91h.05v-1.63h1.88v10.82Zm-1.88-4.38v-1.73c0-.93-.32-1.73-.95-2.4-.63-.67-1.41-1-2.35-1-1.16,0-2.08.42-2.73,1.27-.66.84-.99,2.03-.99,3.55,0,1.31.31,2.36.94,3.15.64.78,1.47,1.17,2.52,1.17s1.91-.38,2.57-1.13c.67-.75,1-1.71,1-2.88Z" />
				<path d="m641.99,258.93h-2.3l-2.76-4.62c-.25-.43-.5-.79-.74-1.09-.24-.31-.48-.56-.74-.75-.25-.19-.51-.33-.8-.41-.28-.09-.6-.14-.96-.14h-1.58v7.01h-1.93v-16.47h4.92c.72,0,1.38.09,1.99.28.61.18,1.14.45,1.58.82.45.37.8.83,1.06,1.38.25.54.38,1.18.38,1.92,0,.57-.09,1.1-.26,1.59-.17.47-.41.9-.74,1.27-.31.38-.7.7-1.15.96-.44.26-.95.46-1.5.61v.05c.28.12.51.26.71.42.21.15.4.34.59.55.18.21.36.46.54.74.18.27.39.58.61.94l3.09,4.95Zm-9.88-14.72v5.97h2.62c.48,0,.93-.07,1.33-.22.41-.15.77-.35,1.07-.62.3-.28.53-.61.7-1,.17-.4.25-.84.25-1.33,0-.88-.29-1.57-.86-2.06-.57-.5-1.39-.75-2.47-.75h-2.64Zm16.72,15c-1.74,0-3.13-.55-4.17-1.64-1.03-1.1-1.55-2.56-1.55-4.38,0-1.98.54-3.52,1.62-4.63,1.08-1.11,2.54-1.67,4.38-1.67s3.12.54,4.1,1.62c.99,1.08,1.48,2.58,1.48,4.49s-.53,3.38-1.6,4.51c-1.06,1.13-2.48,1.69-4.26,1.69Zm.14-10.73c-1.21,0-2.17.41-2.87,1.24-.7.82-1.06,1.95-1.06,3.4s.36,2.49,1.07,3.3,1.67,1.21,2.86,1.21,2.15-.39,2.8-1.18c.66-.79.99-1.91.99-3.37s-.33-2.6-.99-3.4c-.65-.8-1.58-1.19-2.8-1.19Zm13.57,10.73c-1.74,0-3.13-.55-4.17-1.64-1.03-1.1-1.55-2.56-1.55-4.38,0-1.98.54-3.52,1.62-4.63,1.08-1.11,2.54-1.67,4.38-1.67s3.12.54,4.1,1.62c.99,1.08,1.48,2.58,1.48,4.49s-.53,3.38-1.6,4.51c-1.06,1.13-2.48,1.69-4.26,1.69Zm.14-10.73c-1.21,0-2.17.41-2.87,1.24-.7.82-1.06,1.95-1.06,3.4s.36,2.49,1.07,3.3c.71.8,1.67,1.21,2.86,1.21s2.15-.39,2.8-1.18c.66-.79.99-1.91.99-3.37s-.33-2.6-.99-3.4c-.65-.8-1.58-1.19-2.8-1.19Zm25.35,10.45h-1.88v-6.75c0-1.3-.2-2.24-.61-2.83-.4-.58-1.07-.87-2.02-.87-.8,0-1.49.37-2.06,1.1-.56.74-.84,1.62-.84,2.64v6.71h-1.88v-6.98c0-2.31-.89-3.47-2.68-3.47-.83,0-1.51.35-2.04,1.05-.54.69-.8,1.59-.8,2.7v6.71h-1.88v-11.76h1.88v1.86h.05c.83-1.42,2.05-2.14,3.65-2.14.8,0,1.5.23,2.1.68.6.44,1.01,1.03,1.23,1.76.87-1.62,2.17-2.43,3.9-2.43,2.59,0,3.88,1.6,3.88,4.79v7.25Z" />
				<path d="m545.53,283.34h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Zm11.71-6.04c0,1-.09,1.89-.28,2.66-.18.77-.44,1.43-.78,1.96-.34.53-.76.93-1.26,1.21-.5.27-1.06.41-1.69.41-.6,0-1.14-.13-1.61-.39-.47-.27-.86-.65-1.19-1.16-.32-.51-.57-1.13-.73-1.86-.17-.74-.25-1.59-.25-2.54,0-1.05.09-1.97.26-2.77.18-.8.44-1.47.78-2.01.34-.55.76-.95,1.26-1.23.51-.28,1.09-.42,1.74-.42,2.51,0,3.76,2.05,3.76,6.14Zm-1.4.13c0-3.41-.81-5.11-2.43-5.11-1.71,0-2.56,1.73-2.56,5.2,0,3.23.84,4.85,2.51,4.85s2.48-1.65,2.48-4.94Z" />
				<rect x="559.32" y="271.37" width="1.21" height="3.73" />
				<path d="m569.93,279.68c0,.58-.1,1.11-.3,1.59-.2.47-.49.88-.86,1.22-.37.34-.81.6-1.34.78-.52.18-1.1.28-1.74.28-1.11,0-1.94-.17-2.48-.5v-1.45c.81.52,1.64.78,2.5.78.43,0,.82-.06,1.17-.19.35-.13.65-.31.89-.53.24-.23.43-.5.56-.83.13-.32.2-.68.2-1.06,0-.78-.26-1.39-.78-1.83-.52-.45-1.28-.67-2.28-.67-.16,0-.33,0-.51,0-.18,0-.36.01-.53.03-.18,0-.35.01-.53.03-.17.01-.32.03-.46.04l.41-6h5.53v1.24h-4.35l-.24,3.51c.18-.01.37-.02.57-.03.2-.01.38-.02.53-.02.63,0,1.2.08,1.7.25.5.17.92.41,1.27.72.35.31.61.68.79,1.14.18.45.28.95.28,1.5Z" />
				<path d="m573.64,271.37v3.73h-1.21v-3.73h1.21Zm2.77,0v3.73h-1.21v-3.73h1.21Z" />
				<path d="m590.1,274.79l-2.87,4.32,2.82,4.22h-1.59l-1.68-2.77c-.11-.17-.23-.39-.38-.65h-.03c-.03.05-.16.27-.39.65l-1.71,2.77h-1.58l2.91-4.19-2.79-4.36h1.59l1.65,2.92c.12.22.24.44.36.67h.03l2.14-3.59h1.51Z" />
				<path d="m601.06,283.34h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Zm10.29-11.97v7.9h1.54v1.25h-1.54v2.81h-1.35v-2.81h-5.63v-1.19c.52-.59,1.05-1.22,1.59-1.89.53-.67,1.04-1.36,1.53-2.05.49-.69.94-1.38,1.35-2.06.42-.69.77-1.35,1.05-1.98h1.46Zm-5.43,7.9h4.08v-5.86c-.42.73-.81,1.38-1.19,1.95s-.73,1.09-1.07,1.56c-.33.47-.65.89-.96,1.27-.31.38-.6.74-.87,1.08Z" />
				<rect x="614.84" y="271.37" width="1.21" height="3.73" />
				<path d="m623.4,283.34h-1.37v-10.34c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.52.26-.8.38-.28.12-.55.21-.82.28v-1.39c.3-.08.62-.19.95-.33.34-.14.67-.3.99-.48.33-.18.64-.36.93-.55.29-.19.54-.38.75-.57h.52v12.24Z" />
				<path d="m629.16,271.37v3.73h-1.21v-3.73h1.21Zm2.77,0v3.73h-1.21v-3.73h1.21Z" />
				<path d="m808.11,412.14l-2.71,9.59h-1.32l-1.97-7.01c-.08-.3-.14-.62-.15-.98h-.03c-.03.33-.08.65-.17.96l-1.99,7.02h-1.3l-2.81-9.59h1.24l2.04,7.36c.08.31.14.63.16.96h.03c.02-.24.09-.56.21-.96l2.12-7.36h1.08l2.03,7.41c.07.25.12.55.16.9h.03c.02-.23.08-.54.18-.92l1.96-7.38h1.22Z" />
				<polygon points="813.71 412.14 809.11 423.32 808.08 423.32 812.67 412.14 813.71 412.14" />
				<path d="m814.82,421.73v-9.59h2.65c3.38,0,5.07,1.56,5.07,4.67,0,1.48-.47,2.67-1.41,3.57-.94.9-2.19,1.34-3.76,1.34h-2.54Zm1.12-8.57v7.56h1.43c1.26,0,2.24-.34,2.94-1.01.7-.67,1.05-1.63,1.05-2.86,0-2.46-1.31-3.68-3.92-3.68h-1.5Z" />
			</g>
		</g>
	)
}

export default PlanFF
